import { useEffect } from "react";
import { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Text } from "../UI";
import { blue } from "../UI/themes";

const MenuItem = ({
  img,
  title,
  selected,
  navigateTo,
  setTitle,
  isAdmin,
  backgroundColor,
  onItemClicked,
}) => {
  const navigate = useNavigate();
  let theme = useTheme();
  const { t } = useTranslation("menu");

  if (!!isAdmin) {
    theme = blue;
  }

  const handleMenuItemSelect = (navigateTo, title) => {
    if (onItemClicked) {
      onItemClicked();
    } else {
      setTitle(title);
      navigate(navigateTo);
    }
  };

  useEffect(() => {
    if (!selected) return;
    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        alignSelf: "center",
        gap: 1,
        width: 60,
        height: 58,
        position: "relative",
      }}
      onClick={() => handleMenuItemSelect(navigateTo, title)}>
      <div
        title="menu-item"
        style={{
          backgroundColor: selected ? "#EDEDFF" : "transparent",
          position: "relative",
          borderRadius: 16,
          width: 60,
          height: 32,
        }}></div>
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          margin: "0 auto",
          mask: `url(${img}) no-repeat center / contain`,
          backgroundColor: backgroundColor
            ? theme.color.white
            : selected
            ? theme.color.primary
            : theme.color.primary,
          width: 20,
          height: 20,
          marginTop: 3,
        }}></div>
      <Text.H6 style={{ textAlign: "center" }}> {t(title)} </Text.H6>
    </div>
  );
};

export default inject("userStore", "tenantsStore")(observer(MenuItem));
